import React, { useState, useEffect } from 'react';
import Question from './Question';

function SinglePlayerQuiz({ questions, onFinish }) {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0); // Current question index
  const [score, setScore] = useState(0); // Total score
  const [timeLeft, setTimeLeft] = useState(10); // Timer for each question (in seconds)
  const [isGameOver, setIsGameOver] = useState(false);

  const currentQuestion = questions[currentQuestionIndex];

  // Timer logic
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer); // Clear timer on cleanup
    } else {
      endGame('Time is up!'); // End game if time runs out
    }
  }, [timeLeft]);

  const getMultiplier = (difficulty) => {
    switch (difficulty) {
      case 'easy':
        return 1; // Base multiplier
      case 'medium':
        return 2;
      case 'hard':
        return 3;
      default:
        return 1;
    }
  };

  const handleAnswer = (isCorrect) => {
    if (isCorrect) {
      // Calculate score multiplier
      const difficultyMultiplier = getMultiplier(currentQuestion.difficulty);
      const timeMultiplier = timeLeft / 10; // Percentage of time left
      const points = Math.round(100 * difficultyMultiplier * timeMultiplier);

      setScore(score + points); // Update score
      setTimeLeft(10); // Reset timer for the next question

      if (currentQuestionIndex + 1 < questions.length) {
        setCurrentQuestionIndex(currentQuestionIndex + 1); // Move to next question
      } else {
        endGame('You completed all the questions!'); // End game if no more questions
      }
    } else {
      endGame('Incorrect answer!');
    }
  };

  const endGame = (reason) => {
    setIsGameOver(true);
    console.log("Score: ", score);
    onFinish(score, reason); // Pass score and reason for ending the game
  };

  if (isGameOver) {
    return (
      <div className="game-over">
        <h2>Game Over</h2>
        <p>Reason: {onFinish.reason}</p>
        <p>Your Final Score: {score}</p>
      </div>
    );
  }

  return (
    <div className="quiz">
      <h3>Score: {score}</h3>
      {/* Timer Progress Bar */}
      <div className="timer-container">
        <div
          className="timer-bar"
          style={{
            width: `${(timeLeft / 10) * 100}%`, // Adjust width based on time left
            transition: 'width 1s linear', // Smooth shrinking animation
          }}
        ></div>
      </div>
      <Question
        questionData={currentQuestion}
        onAnswer={(isCorrect) => handleAnswer(isCorrect)}
      />
    </div>
  );
}

export default SinglePlayerQuiz;
